module.exports = __webpack_public_path__ + "static/media/review-logo.54052daf.svg";